module.exports = __webpack_public_path__ + "img/regret.df65372b.png";